import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore/createContextStore";
var INITIAL_STATE = {
    brandToken: undefined,
    existingEmail: undefined,
    showBanner: false,
    email: undefined,
    brand: undefined,
    salesforceOwnerUrl: undefined,
    isLoading: false,
    isMarketSectionVisible: false,
    makerSignUpState: undefined
};
var _createContextStore = createContextStore(INITIAL_STATE, {
    name: "BrandsLandingPageContext"
}), useBrandsLandingPageStore = _createContextStore.useStore, BrandsLandingPageProvider = _createContextStore.Provider;
export { useBrandsLandingPageStore, BrandsLandingPageProvider };
